import { passwordStrength } from "check-password-strength";
const PASSWORD_STRENGTH_PARAMS = [
    {
        id: 0,
        value: "Too weak",
        minDiversity: 0,
        minLength: 0,
    },
    {
        id: 1,
        value: "Weak",
        minDiversity: 2,
        minLength: 4,
    },
    {
        id: 2,
        value: "Medium",
        minDiversity: 4,
        minLength: 8,
    },
    {
        id: 3,
        value: "Strong",
        minDiversity: 4,
        minLength: 10,
    },
];
export const passwordConditions = (password) => {
    const strengthOptions = PASSWORD_STRENGTH_PARAMS.map((option) => ({ ...option }));
    const hasSpecialAndNumberChars = (target) => {
        const hasSpecialChars = !/^[a-zA-Z0-9]*$/.test(target);
        const hasNumbers = /\d/.test(target);
        const hasLowerCase = /[a-z]/.test(target);
        const hasUpperCase = /[A-Z]/.test(target);
        return hasSpecialChars && hasNumbers && hasLowerCase && hasUpperCase;
    };
    const getStrength = (target) => {
        return passwordStrength(target, strengthOptions);
    };
    const length = password.length;
    const specialChars = hasSpecialAndNumberChars(password);
    const strength = getStrength(password);
    return {
        strength,
        length,
        specialChars,
    };
};
